<template>
  <div class="box">
    <div class="scrollbox">
      <div class="titlebox">
        <p
          class="titleText"
        >{{langText["challengeText"]}}</p>
      </div>
      <div class="titleLineBox">
        <span>{{langText["menuText3"]}}</span>
      </div>
      <div class="challengeUl">
        <div
          class="challengeItem"
          v-for="(item, index) in menus"
          v-bind:key="index"
          @click="chooseItem(index)"
        >
          <div
            class="indexNum"
            :class="selectIndex == index?'chooseTextStyle':'normalTextStyle'"
          >{{index+1}}.</div>
          <div class="detailText" :class="selectIndex == index?'chooseTextStyle':'normalTextStyle'">
            <p>{{isArab? item.name : item.name_en}}</p>
          </div>
          <div class="checkIcon" v-if="can_vote">
            <div class="checkedIcon" v-if="selectIndex == index"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="btnArea" v-if="!isHostSelf">
      <div class="voteBtn" :class="can_vote?'btnActive':'btnUnactive'"  @click="voteFn">{{langText["vote"]}}</div>
    </div>
    <ErrorPop :errdata="popmes" @submit="closePop" v-if="showpop"></ErrorPop>
  </div>
</template>

<script>
import {_di} from './../common/js/di';
import {lang} from './../language/kol';
import ErrorPop from './ErrorPop';
export default {
  name: "ChallengeComponent",
  props: {
    detailData: {
        can_vote: "",
        menus:[],
    }
  },
  watch: {
    detailData(newValue,oldValue){
        this.can_vote = newValue.can_vote;
        this.menus = newValue.menus;
    }
  },
  components: {ErrorPop},
  data() {
    return {
      userId: "",
      host_id: "",
      token: "",
      selectIndex: 0,
      can_vote: false,
      menus: [],
      langType: "",
      langText: {},
      showpop: false,
      popmes: "",
      isHostSelf: false,
      isArab: false,
    };
  },
  mounted() {
    this.baseUrl = process.env.BASEURL;
    this.kolurl = process.env.KOLURL;
    this.userId = this.getUrlParam("userId") || 1002813;
    this.host_id = this.getUrlParam("hostId") || 1002812;
    this.token = this.getUrlParam("token") || "";
    this.langType = this.getUrlParam('lang') === 'ar' ? 'ar' : 'en';
    this.langText = lang[this.langType];
    this.isArab = this.langType == "ar"?true: false;
    if(this.host_id == this.userId){
        this.isHostSelf = true;
        this.selectIndex = null;
    }
    //di打点相关
    this.eventTrack = {
        kol_vote_challenge: _di('kol.vote.challenge',42626),
    }
  },
  methods: {
    initData() {
      
     
    },
    closePop() {
      this.showpop = false;
    },
    showPop(mes) {
       this.popmes = mes;
       this.showpop = true;
    },
    chooseItem(index) {
      if(this.can_vote){
        this.selectIndex = index;
      }
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    voteFn() {
      if(!this.can_vote){
          return
      }
      var chooseId = this.menus[this.selectIndex].id;
      var params = {
        host_id: this.host_id,
        uid: this.userId,
        menu_id: chooseId
      };
      var postUrl = "/kol/landing-vote";
      var wholeUrl =
        this.kolurl + postUrl + "?uid=" + this.userId + "&token=" + this.token;
      this.$axios.post(wholeUrl, params).then(response => {
        var resData = response.data;
        if(!!resData.ok){
           this.getLandInfo();
            //打点
            this.eventTrack.kol_vote_challenge({
                "user_id": this.userId,
                "source": chooseId,
            });
        }else{
            this.showPop(resData.msg);
        }
        console.log(resData);
        
      });
      
    },
    getLandInfo() {
      var url = this.kolurl + "/kol/landing-info";
      var params = {
        host_id: this.host_id,
        uid: this.userId,
        token: this.token
      };
      this.$axios.get(url,{ params:params}).then(response => {
        //    console.log(response.data);
        var resData = response.data;
        this.can_vote = resData.can_vote;
        this.selectIndex = 0;
        this.menus = resData.menus;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.scrollbox {
  width: 100%;
  height: 3.2rem;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.titlebox {
  width: 2.63rem;
  margin-top: 0.2rem;
}
.titleText {
  line-height: 0.18rem;
  font-size: 0.14rem;
  color: rgb(171, 173, 186);
  text-align: center;
}
.titleLineBox {
  height: 0.24rem;
  line-height: 0.24rem;
  color: rgb(113, 113, 123);
  font-size: 0.15rem;
  margin-top: 0.1rem;
  margin-bottom: 0.15rem;
}
.titleLineBox::before {
  content: "";
  display: inline-block;
  width: 1.3rem;
  margin: 0.04rem 0.05rem;
  border-bottom: 1px solid rgb(226, 226, 226);
}
.titleLineBox::after {
  content: "";
  display: inline-block;
  width: 1.3rem;
  margin: 0.04rem 0.05rem;
  border-bottom: 1px solid rgb(226, 226, 226);
}
.challengeUl {
  width: 3.25rem;
}
.challengeItem {
  width: 3.25rem;
  display: flex;
  justify-content: space-between;
  /* background: yellow; */
  font-size: 0.15rem;
  margin-bottom: 0.15rem;
}
.indexNum {
  width: 0.18rem;
  height: 0.16rem;
  line-height: 0.16rem;
}
.detailText {
  width: 2.95rem;
}
.detailText p {
  line-height: 0.18rem;
}
.chooseTextStyle {
  color: rgb(234, 48, 127);
}
.normalTextColor {
  color: rgb(113, 113, 123);
}
.checkIcon {
  width: 0.16rem;
  height: 0.16rem;
  border-radius: 0.08rem;
  border: 1px solid rgb(242, 242, 242);
  box-shadow: 0.5px -1.5px 2.5px rgba(145, 145, 145, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.checkedIcon {
  width: 0.08rem;
  height: 0.08rem;
  border-radius: 0.04rem;
  background: rgb(234, 48, 127);
}
.btnArea {
  width: 100%;
  height: 0.8rem;
  position: fixed;
  left: 0;
  bottom: 0;
  background: rgb(247, 247, 247);
  display: flex;
  justify-content: center;
  align-items: center;
}
.voteBtn {
  width: 2.2rem;
  height: 0.4rem;
  border-radius: 0.2rem;
  line-height: 0.4rem;
  text-align: center;
  font-size: 0.15rem;
  font-weight: bolder;
}
.btnActive {
  color: #fff;
  font-weight: bolder;
  box-shadow: 0 2.5px 7.5px rgba(233, 50, 123, 0.4);
  background: linear-gradient(rgb(233, 50, 123), rgb(239, 36, 152));
}
.btnUnactive {
  color: rgb(182, 182, 183);
  font-weight: bolder;
  box-shadow: 0 2.5px 7.5px rgba(183, 183, 183, 0.4);
  background: linear-gradient(rgb(214, 214, 214), rgb(224, 223, 223));
}
</style>



// WEBPACK FOOTER //
// src/components/KolChallenge.vue